// app/javascript/controllers/connectivity_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'status',
    'onlineIcon',
    'offlineIcon',
    'placeholder',
    'statusDescription',
    'modal',
    // 'onlineModal',
    // 'offlineModal',
  ];

  connect() {
    console.log('connectivity controller connected!');
    this.checkInternetAccess();
    window.addEventListener('online', () => this.updateOnlineStatus(true));
    window.addEventListener('offline', () => this.updateOnlineStatus(false));
  }

  checkInternetAccess(url = 'https://www.google.com/favicon.ico', timeout = 5000) {
    // Quick check using navigator.onLine
    if (!navigator.onLine) {
      this.updateOnlineStatus(false);
      return;
    }

    fetch(url, { method: 'HEAD', mode: 'no-cors' })
      .then(() => this.updateOnlineStatus(true))
      .catch(() => this.updateOnlineStatus(false));
  }

  updateOnlineStatus(isOnline) {
    console.log('updatOnlineStatus');
    if (isOnline) {
      // this.onlineIconTarget.classList.remove('hidden');
      this.offlineIconTarget.classList.add('hidden');
      // this.placeholderTarget.classList.add('hidden');
      this.statusDescriptionTarget.textContent = 'Online';
      // this.onlineModalTarget.classList.remove('hidden');
    } else {
      // this.onlineIconTarget.classList.add('hidden');
      this.offlineIconTarget.classList.remove('hidden');
      // this.placeholderTarget.classList.add('hidden');
      this.statusDescriptionTarget.textContent = 'Offline';
      // this.offlineModalTarget.classList.remove('hidden');
      this.setLinksActive(isOnline);
    }
  }

  async setLinksActive(isOnline) {
    console.log('setLinksActive');
    const links = document.querySelectorAll('a:not([data-ignore-connectivity="true"])');
    console.log('links:', links);
    const cachedPaths = await this.getCachedPaths();
    console.log('Cached Paths:', cachedPaths);

    links.forEach(async (link) => {
      const isCached = await this.isLinkCached(link.href, cachedPaths);
      let offlineMessageElement = document.getElementById('offline-message');
      let backgroundSyncNotSupported = false;

      if (offlineMessageElement) {
        if (offlineMessageElement.getAttribute('data-background-sync') === 'false') {
          backgroundSyncNotSupported = true;
        }
      }

      if (!isCached || backgroundSyncNotSupported) {
        link.style.color = 'gray'; // Change color to gray for uncached links or if background sync is not supported
      }

      link.addEventListener('click', async (event) => {
        if (isCached) {
          this.modalTarget.classList.add('hidden');
        } else {
          event.preventDefault(); // Prevent default click behavior
          this.modalTarget.classList.remove('hidden');
        }
      });
    });
  }

  toggle() {
    this.modalTarget.classList.add('hidden');
  }

  isLinkCached(linkUrl, cachedPaths) {
    // Check if the link URL is in the list of cached paths
    console.log('is cached');
    return cachedPaths.includes(linkUrl);
  }

  // ...

  async getCachedPaths() {
    console.log('getCachedPaths');

    try {
      // Check if the Cache Storage is available
      if ('caches' in window) {
        const cache = await caches.open('documents'); // Open the desired cache (change 'documents' to your cache name)
        console.log('cache:', cache);

        const cacheKeys = await cache.keys(); // Get all keys (URLs) in the cache
        const cachedPaths = cacheKeys.map((key) => key.url);

        console.log('Cached Paths:', cachedPaths);
        return cachedPaths;
      } else {
        console.warn('Cache Storage not available.');
        return [];
      }
    } catch (error) {
      console.error('Error in getCachedPaths:', error);
      return [];
    }
  }
}
